(() => {
  'use strict';
  const init = (root) => {
    if (root.dataset.snReady) return;
    root.dataset.snReady = 'true';
    const dialog = root.querySelector('.sn-dialog');
    const enlarged = dialog?.querySelector('[data-sn-enlarged]');
    const caption = dialog?.querySelector('[data-sn-caption]');
    let trigger;
    if (dialog && enlarged && caption && typeof dialog.showModal === 'function') {
      root.addEventListener('click', (event) => {
        const link = event.target.closest('[data-sn-image]');
        if (!link || !root.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        trigger = link;
        const source = link.querySelector('img');
        enlarged.src = link.href;
        enlarged.alt = source?.alt || '';
        enlarged.width = Number(source?.getAttribute('width')) || 1218;
        enlarged.height = Number(source?.getAttribute('height')) || 1582;
        caption.textContent = link.dataset.caption || '';
        dialog.classList.remove('sn-dialog--full');
        const sizeButton = dialog.querySelector('[data-sn-size]');
        sizeButton.textContent = 'Read full size';
        sizeButton.setAttribute('aria-pressed', 'false');
        dialog.showModal();
        dialog.querySelector('.sn-dialog-scroll').scrollTop = 0;
        dialog.querySelector('.sn-dialog-scroll').scrollLeft = 0;
        dialog.querySelector('[data-sn-close]').focus();
      });
      dialog.querySelector('[data-sn-close]')?.addEventListener('click', () => dialog.close());
      dialog.querySelector('[data-sn-size]')?.addEventListener('click', (event) => {
        const full = dialog.classList.toggle('sn-dialog--full');
        event.currentTarget.textContent = full ? 'Fit to screen' : 'Read full size';
        event.currentTarget.setAttribute('aria-pressed', String(full));
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => trigger?.focus({ preventScroll: true }));
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(dialog.querySelectorAll('button, [tabindex="0"]'));
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    }
    const checkout = root.querySelector('[data-sn-checkout]');
    const status = checkout?.querySelector('.sn-checkout-status');
    if (checkout && status) {
      const onFrame = () => {
        const frame = checkout.querySelector('iframe');
        if (!frame) return false;
        if (!frame.title) frame.title = 'Secure Study Notes order form';
        frame.addEventListener('load', () => { status.hidden = true; }, { once: true });
        status.textContent = 'Your secure order form is below.';
        return true;
      };
      if (!onFrame()) {
        const observer = new MutationObserver(() => { if (onFrame()) observer.disconnect(); });
        observer.observe(checkout, { childList: true, subtree: true });
        // Disconnect if the vendor is blocked; the permanent direct checkout link remains available.
        setTimeout(() => { observer.disconnect(); if (!checkout.querySelector('iframe')) status.textContent = 'If the form does not appear, use the secure checkout link below.'; }, 20000);
      }
    }
  };
  document.querySelectorAll('[data-study-notes]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-study-notes]').forEach(init));
})();
